// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__248pS","tab":"Tabs_tab__2Q3a3","tabActive":"Tabs_tabActive__1aoT-"};